import { useLocation } from "react-router";

interface CurrentLibraryChannel {
	name: string;
}

/*
 * Provides a non-url identifier for the Library page the user
 * is currently in, based on the current URL. The path patterns
 * track the ones used by the Application router (see src/components/App).
 *
 * In the case where the user is NOT in the library (i.e. none of the
 * patterns match and the user is on another page entirely), then
 * the channel is "NOT_IN_LIBRARY".
 */
function useCurrentLibraryChannel(): CurrentLibraryChannel {
	const { pathname } = useLocation();

	let channelName = "NOT_IN_LIBRARY";

	if (pathname === "/library/") channelName = "ALL_MEETINGS";
	else if (pathname.startsWith("/library/my-meetings")) channelName = "MY_MEETINGS";
	else if (pathname.startsWith("/library/shared-with-me")) channelName = "SHARED_WITH_ME";
	else if (pathname.startsWith("/library/watch-later")) channelName = "WATCH_LATER";
	else if (pathname.startsWith("/library/uploads")) channelName = "UPLOADS";
	else if (pathname.startsWith("/library/c/")) channelName = "OTHER_CHANNEL";

	return { name: channelName };
}

export default useCurrentLibraryChannel;
